var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSupportSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,10h-1c0-2.7539062-1.1533203-5.4140625-3.1630859-7.2978516c-2.0371094-1.9091797-4.6933594-2.8642578-7.5-2.6806641 C10.2019043,0.3538818,6.1676025,4.7097778,6.0145264,10H5c-2.7568359,0-5,2.2431641-5,5v2c0,2.7568359,2.2431641,5,5,5h1 c1.1025391,0,2-0.8974609,2-2v-9.6914062c0-4.3779297,3.2792969-8.0205078,7.4658203-8.2910156 C17.7021484,1.875,19.8388672,2.6337891,21.4697266,4.1611328C23.1015625,5.6914062,24,7.7646484,24,10v12 c0,3.3085938-2.6914062,6-6,6h-0.8892822C16.8361816,27.6951904,16.4425049,27.5,16,27.5c-0.8284302,0-1.5,0.6715698-1.5,1.5 s0.6715698,1.5,1.5,1.5c0.4425049,0,0.8361816-0.1951904,1.1107178-0.5H18c4.4111328,0,8-3.5888672,8-8h1 c2.7568359,0,5-2.2431641,5-5v-2C32,12.2431641,29.7568359,10,27,10z M5,20c-1.6542969,0-3-1.3457031-3-3v-2 c0-1.6542969,1.3457031-3,3-3h1l0.0019531,8H5z M30,17c0,1.6542969-1.3457031,3-3,3h-1v-8h1c1.6542969,0,3,1.3457031,3,3V17z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSupportSmall);
export default __webpack_public_path__ + "static/media/account-support--small.251a62bd67a37b5510ab48943d10a2a0.svg";
export { ForwardRef as ReactComponent };